import { cn } from "@/lib/utils";

interface CharacterLimitNoteProps {
  /** Current number of characters in the field. */
  length: number;
  /** The field's character limit, or null when it has none. */
  maxLength: number | null;
}

/**
 * Shows how much of a field's character limit is used, in the destructive color once over it.
 * @param props - The current length and the limit
 * @returns The note, or null when the field has no limit
 */
export function CharacterLimitNote({
  length,
  maxLength,
}: CharacterLimitNoteProps) {
  if (maxLength === null) {
    return null;
  }
  return (
    <p
      className={cn(
        "mt-1 text-right text-xs tabular-nums",
        length > maxLength ? "text-destructive" : "text-muted-foreground",
      )}
    >
      {length}/{maxLength} characters
    </p>
  );
}
